import { Component } from 'react'
class SectionCBASE extends Component {

    state= {
        content: [
            { 
                emoji: "🔍",
                name: "Explorer",
                link: ["https://explorer.bitquery.io/bsc/token/0x00ca13fc2b97805849db46547fe991c760c6bd33"],
                linkTitle: ["Bitquery"],
                indications:""
            },
            { 
                emoji: "📃",
                name: "Contract",
                link: ["https://bscscan.com/address/0x00ca13fc2b97805849db46547fe991c760c6bd33"],
                linkTitle: ["BscScan"],
                indications:""
            },
            { 
                emoji: "💲",
                name: "Token",
                link: ["https://bscscan.com/token/0x00ca13fc2b97805849db46547fe991c760c6bd33"],
                linkTitle: ["BscScan"],
                indications:""
            },
            { 
                emoji: "💸",
                name: "Trade",
                link: ["https://dex.guru/token/0x00ca13fc2b97805849db46547fe991c760c6bd33-bsc",
                        "https://exchange.pancakeswap.finance/#/swap"],
                        linkTitle: ["dex.guru","PancakeSwap"],
                indications:`Add address "0x8f4fc37bff97e6e7fd4355a5df76a486ac1e2e1c" to "Select a token" and set SLIPPAGE 12% in the options.`
            },
            { 
                emoji: "🧫",
                name: "Liquidity pool",
                link: ["https://exchange.pancakeswap.finance/#/add/BNB"],
                linkTitle: ["PancakeSwap"],
                indications: `Add  address "0x00ca13fc2b97805849db46547fe991c760c6bd33" to "Select a currency".`
            },
            { 
                emoji: "🔒",
                name: "Liquidity lock",
                link: ["https://bscscan.com/address/0x301B43235831b0cEA906c0E88D4c076650BfF951"],
                linkTitle: ["Timelock Contract"],
                indications:""
            },
            { 
                emoji: "📈",
                name: "Chart",
                link: ["https://charts.bogged.finance/?token=0x00ca13fc2b97805849db46547fe991c760c6bd33",
                        "https://poocoin.app/tokens/0x00ca13fc2b97805849db46547fe991c760c6bd33"],
                        linkTitle: ["BoggedFinance","PooCoin"],
                indications:""
            },
            { 
                emoji: "🔥",
                name: "Staking",
                link: ["https://stak.cbase.ctena.finance/"],
                linkTitle: ["Stake CBASE-BNB CAKELP"],
                indications:""
            },
            { 
                emoji: "🔒",
                name: "Mint",
                link: ["https://mint.xcbase.ctena.finance"],
                linkTitle: ["Mint xCBASE"],
                indications:"XBASE Compound Token"
            },
        ]
    }

     copyToClipboard = (e) => {
        const el = document.createElement('textarea');
        el.value = "0x00ca13fc2b97805849db46547fe991c760c6bd33";
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        e.target.innerHTML=" Copied! :)";
        setTimeout(() => {
            e.target.innerHTML=" Copy Address";  
        }, 3000);
      };
      
    render () {
        return (
            <div className="section-wrap" id="cbase-wrap">
                <p id="faq-title">CBASE</p>
                <div id="intro-buttons">
                <a href="https://cbase.ctena.finance"><button>Dashboard</button></a>
                <a href="https://stak.cbase.ctena.finance"><button>Staking</button></a>
                <a href="https://swap.arken.finance/tokens/bsc/0x00ca13fc2b97805849db46547fe991c760c6bd33"><button>Buy</button></a>
                <a href="https://pancakeswap.finance/add/BNB/0x00ca13fc2b97805849db46547fe991c760c6bd33"><button>Add Liquidity</button></a>
                </div>
                <div className="section-wrap" id="faq-wrap">
                <div id="info-txt">
                    <p>
                    The goal of <span>CBASE</span> is to maintain a stable price of 1$.

                    In order to achieve this, our supply will adapt to changes in demand. All supply changes apply equally to every wallet holding CBASE. You will always have the same % of the total supply.

                    The supply changes occur during an event called Rebase. A Rebase can be negative (supply shrinks) or positive (supply grows). If the price target is met no Rebase is needed and the supply will remain unchanged.
                    </p>

                </div>
                <div id="info-txt">
                    <p> <span>Elastic supply</span> </p>
                    <p>Our supply is like CBASE. It has the ability to rearrange its entire cell structure according to the current price.
                    </p>
                   
                </div>
                <div id="info-txt">
                    <p> <span>Dynamic rebases</span> </p>
                    <p>Negative rebases are amplified to make CBASE return into positive rebase territory faster. This prevents long periods of negative rebases. Rebases can also be triggered up to 6 times per day, resulting in a token that maintains its peg very efficiently.

                    </p>
                   
                </div>
                <div id="info-txt">
                    <p> <span>Stable peg</span> </p>
                    <p>Just like its real-life counterpart, CBASE token efficiently morphs in the form required to maintain a $1 peg. This makes CBASE a stable store of value that is unaffected by the volatility that plagues other cryptocurrencies.
                    </p>
                   
                </div>
                <div id="info-txt">
                    <p> <span>Fast, low cost transactions</span> </p>
                    <p>
                     Since CBASE runs on Binance Smart Chain, CBASE users and liquidity providers pay very little fees and get quick confirmations.
                    </p>
                   
                </div>
                <div id="info-txt">
                    <p> <span>Trustless oracles</span> </p>
                    <p>
CBASE uses time-weighted average price (TWAP) price feeds generated by on-chain AMMs. There is no dependence on external Oracles that could be manipulated.
                    </p>
                   
                </div>
                <div id="info-txt">
                    <p> <span>Community governance</span> </p>
                    <p>
CBASE is first and foremost a community project. CBASE token holders vote on all important decisions such as protocol updates and changes to the monetary policy.
                    </p>
                   
                </div>




            </div>
                { this.state.content.map( (box, index) => (
                    <div key={index} className="question-box">
                        <p className="question-q"><span className="question-q1">{box.emoji}</span>
                            <span className="question-q2">{box.name}</span>
                            {(box.indications === "")? null : <span class="copy-address-button" onClick={e => this.copyToClipboard(e)}> Copy Address </span>}
                        </p>
                        <div  className="question-boxForButtons">
                            {box.link.map( (link, index) => <a href={link} target="_blank"><button key={index}> {box.linkTitle[index]}</button> </a>)}
                        </div>
                        {(box.indications === "")? null : <p key={index} className="question-indications"> {box.indications}</p>}
                    </div>
                ))
                }
                

                

          

            </div>
  
        )
    }
}

export default SectionCBASE
